<template>
  <div>
    <Row :gutter="24">
      <!-- <Col :span="4">
        <Card>
          <p slot="title">待分配预约单</p>

          <Button
            slot="extra"
            style="margin-left: 30px"
            type="primary"
            @click="ReFresh()"
            icon="md-barcode"
            >刷新数据</Button
          >
          <div>
            <Select v-model="sel_field" style="width: 200px">
              <Option
                v-for="item in sel_values"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
            <Input
              v-model="queryvalue"
              placeholder="输入要查询的内容"
              style="width: 200px"
            ></Input>
            <Button type="primary" @click="Search" icon="ios-search"
              >搜索</Button
            >
          </div>

          <div class="datatable">
            <Table
              highlight-row
              :border="false"
              size="small"
              @on-sort-change="Sort"
              :columns="table.tablecolumsTitle"
              :loading="table.loading"
              :data="table.datalist"
              @on-current-change="RowSel"
            ></Table>
          </div>
        </Card>
      </Col> -->
      <Col :span="18">
        <Card>
          <p slot="title">试压地址</p>
          <Button
            slot="extra"
            style="margin-left: 30px"
            type="primary"
            @click="ReFresh()"
            icon="md-barcode"
            >刷新数据</Button
          >

          <div id="map_container" style="width: 100%; height: 900px"></div>
          <div id="toolControl">
            <div
              @click="openMuiltSel"
              :class="['toolItem', { active: enableMuiltSel }]"
              id="rectangle"
              title="框选多个点"
            ></div>
          </div>
          <p>
            地图中自动展示待分配的试压单。
            <br />
            1.红色标记为已预选试压员，蓝色标记为还未选试压员
            <br />
            2.鼠标左键点击标记可查看小区/地址/试压员详情
            <br />
            3.双击可以加入右边临时列表，方便批量分配试压员
            <br />
            4.点击地图中间的框选模式,可以一次选择一批地点加入临时列表
          </p>
        </Card>
      </Col>
      <Col :span="6">
        <Card>
          <p slot="title">已选中预约单</p>
          <Button
            slot="extra"
            style="margin-left: 30px"
            type="primary"
            @click="ModelShow()"
            icon="md-barcode"
            >预选试压员</Button
          >
          <Table
            :border="false"
            size="small"
            :columns="tempTable.tablecolumsTitle"
            :data="tempTable.datalist"
          ></Table>
        </Card>
      </Col>
    </Row>
    <Modal
      title="选择试压员"
      @on-cancel="ModalCancel"
      width="1000"
      height="600"
      :footer-hide="true"
      v-model="workermodal.show"
    >
      <worker-RowSel
        v-if="workermodal.show"
        v-on:rowsel="WorkerRowSel"
      ></worker-RowSel>
    </Modal>
  </div>
</template>

<script>
// 引入加载AMap的方法
import AMap from "@/utils/initMap";
import workerRolSel from "../../components/public_component/workerRowSel";
export default {
  data() {
    return {
      // 地图运行时对象不要放 data，否则 Vue2 会深层劫持 AMap 实例，拖动更卡
      enableMuiltSel: false,
      workermodal: {
        show: false,
      },
      region:'',

      queryvalue: "",

      sel_field: "",
      sel_values: [
        { value: "RegionFullDesc", label: "行政区" },
        { value: "WorkerName", label: "试压员" },
        { value: "Address", label: "地址" },
      ],

      table: {
        tablecolumsTitle: [
          {
            title: "地址",
            key: "Address",
            width: 180,
            align: "center",
            tooltip: true,
            sortable: "custom",
          },
          {
            title: "行政区",
            key: "RegionFullDesc",
            width: 145,
            align: "center",
            tooltip: true,
            sortable: "custom",
          },
          {
            title: "试压员",
            key: "WorkerName",
            width: 100,
            align: "center",
            tooltip: true,
            sortable: "custom",
          },
        ],
        datalist: [],
        pageIndex: 1,
        total: 0,
        pageSize: 100,
        loading: true,
        sort: " ",
      },
      tempTable: {
        tablecolumsTitle: [
          {
            title: "地址",
            key: "Address",
            width: 180,
            align: "center",
            tooltip: true,
          },
          {
            title: "试压员",
            key: "WorkerName",
            width: 100,
            align: "center",
            tooltip: true,
            sortable: "custom",
          },
          {
            title: "操作",
            key: "bus",
            width: 80,
            align: "center",

            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    style: { marginRight: "3px" },
                    on: {
                      click: () => {
                        this.RemoveTemp(params.row);
                      },
                    },
                  },
                  "移除"
                ),
              ]);
            },
          },
        ],
        datalist: [],
        pageIndex: 1,
        total: 0,
        pageSize: 100,
        loading: false,
        sort: " ",
      },
    };
  },
  methods: {
    PageChange: function (e) {
      this.table.pageIndex = e;
      this.GetTableList();
    },

    ReFresh: function () {
      this.GetTableList();
    },
    Search: function (e) {
      this.loading = true;
      var conditions = [];
      if (this.sel_field != "" && this.queryvalue.trim() != "") {
        conditions.push({
          PropertyName: this.sel_field,
          Operater: 0,
          LogicOperater: 0,
          Value: this.queryvalue.trim(),
        });
      }
      this.$http.SetConditions(conditions);
      this.GetTableList();
    },
    GetTableList: function () {
      var that = this;
      that.table.loading = true;
      that.$http
        .get("PrePress/GetPrePressMapPageList", {
          params: {
            pageIndex: that.table.pageIndex,
            pageSize: that.table.pageSize,
            sort: that.table.sort,
            status: 30, //只查待分配试压的
            region: that.region
          },
        })
        .then((res) => {
          res.data.ListData.map((item) => {
            item.WorkerName = item.WorkerName || "未分配";
            item.IsAddTemp = 0;
          });

          that.table.loading = false;
          that.table.datalist = res.data.ListData;
          that.table.total = res.data.TotalCount;
          that.table.pageSize = res.data.PageSize;
          if (res.data.ListData.length > 0) {
            that.renderMarkers();
            that.SetTemptableList();
            that.fitMapToMarkers();
          } else if (that.labelsLayer) {
            that.labelsLayer.clear();
            that.markers = [];
            that.markerMap = {};
            that.SetTemptableList();
          }
        });
    },

    ModalCancel: function (e) {
      console.log("取消");
      this.$http.SetConditions();
    },
    ModelShow: function () {
      var that = this;
      this.$http.SetConditions();
      this.workermodal.show = true;
    },
    WorkerRowSel: function (e) {
      var that = this;
      console.log(e.ID);
      var preressIds = [];
      this.tempTable.datalist.map((item) => {
        preressIds.push(item.ID);
      });

      this.$http
        .post(`Prepress/PreSetWorkerList?workerid=${e.ID}`, preressIds)
        .then((res) => {
          if (res.data == "success") {
            that.$Modal.success({
              title: "操作提醒",
              content: "预分配成功",
            });
          } else {
            that.$Message.warning(res.data);
          }
          this.workermodal.show = false;
          that.GetTableList();
        });
    },
    SetTemptableList: function () {
      var tempTableList = [];
      this.table.datalist.map((item) => {
        if (item.IsAddTemp == 1) {
          tempTableList.push(item);
        }
      });
      this.tempTable.datalist = tempTableList;
    },
    RemoveTemp: function (evt) {
      this.table.datalist.map((item) => {
        if (item.ID == evt.ID) {
          item.IsAddTemp = 0;
        }
      });
      this.SetTemptableList();
    },
    Sort: function (sort) {
      if (sort.key != undefined && sort.order != undefined) {
        if (sort.order != "normal") {
          this.table.sort = sort.key + " " + sort.order;
        } else {
          this.table.sort = "";
        }
      }
      this.GetTableList();
    },

    RowSel: function (currentRow, oldCurrentRow) {
      console.log(currentRow, oldCurrentRow);
      var pos = new this.AMapNS.LngLat(currentRow.Lgt, currentRow.Lat);
      this.map.panTo(pos);
      this.map.setZoom(15);
      this.openPointInfo(currentRow, pos);
    },

    openPointInfo: function (data, position) {
      var lat = data.Lat;
      var lng = data.Lgt;
      this.initWindow(
        lat,
        lng,
        data.Address,
        data.PrepressStatus || data.PreressStatus,
        data.WorkerName,
        data.Title
      );
      var pos =
        position ||
        new this.AMapNS.LngLat(lng * 1, lat * 1);
      this.infoWin.open(this.map, pos);
    },

    // 按标记点适配视野：单点直接放大到街道级；多点尽量看全但限制最小缩放
    fitMapToMarkers() {
      if (!this.map || !this.markers || this.markers.length === 0) {
        return;
      }
      var minZoom = 12;
      var singleZoom = 15;
      if (this.markers.length === 1) {
        var pos = this.markers[0].getPosition();
        this.map.setZoomAndCenter(singleZoom, pos, true);
        return;
      }
      this.map.setFitView(this.markers, true, [60, 60, 60, 60]);
      if (this.map.getZoom() < minZoom) {
        this.map.setZoom(minZoom, true);
      }
    },

    ensureLabelsLayer: function () {
      var AMap = this.AMapNS;
      if (this.labelsLayer) {
        this.labelsLayer.clear();
        return this.labelsLayer;
      }
      this.labelsLayer = new AMap.LabelsLayer({
        zooms: [3, 20],
        zIndex: 1000,
        // 只要色点区分状态，关闭避让以免拖动时频繁重算
        collision: false,
        allowCollision: false,
      });
      this.map.add(this.labelsLayer);
      return this.labelsLayer;
    },

    // LabelsLayer 批量标注（替代大量独立 Marker + HTML 标签）
    renderMarkers() {
      var that = this;
      var AMap = this.AMapNS;
      if (!this.map || !AMap) return;

      var layer = this.ensureLabelsLayer();
      this.markers = [];
      this.markerMap = {};

      var iconBlue = {
        type: "image",
        image: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        size: [16, 22],
        anchor: "bottom-center",
      };
      var iconRed = {
        type: "image",
        image: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
        size: [16, 22],
        anchor: "bottom-center",
      };

      var labelMarkers = [];
      this.table.datalist.forEach(function (item) {
        var assigned = item.WorkerName !== "未分配";
        var markerOpts = {
          name: String(item.ID),
          position: [item.Lgt * 1, item.Lat * 1],
          zIndex: assigned ? 120 : 100,
          rank: 1,
          icon: assigned ? iconRed : iconBlue,
          extData: {
            ID: item.ID,
            Address: item.Address,
            Title: item.Title,
            WorkerName: item.WorkerName,
            PrepressStatus: item.PrepressStatus,
            Lat: item.Lat,
            Lgt: item.Lgt,
          },
        };
        // 有小区名才常驻标签：小区 · 试压员
        if (item.Title) {
          markerOpts.text = {
            content: item.Title + " · " + (item.WorkerName || "未分配"),
            direction: "top",
            offset: [0, -2],
            style: {
              fontSize: 12,
              fontWeight: "normal",
              fillColor: "#333",
              strokeColor: "#fff",
              strokeWidth: 2,
              padding: [2, 6],
              backgroundColor: "rgba(255,255,255,0.95)",
              borderColor: "#ddd",
              borderWidth: 1,
            },
          };
        }
        var labelMarker = new AMap.LabelMarker(markerOpts);

        labelMarker.on("click", function (e) {
          var data =
            (labelMarker.getExtData && labelMarker.getExtData()) ||
            (e && e.data && e.data.data && e.data.data.extData) ||
            item;
          var pos =
            (labelMarker.getPosition && labelMarker.getPosition()) ||
            new AMap.LngLat(data.Lgt * 1, data.Lat * 1);
          that.openPointInfo(data, pos);
        });

        labelMarker.on("dblclick", function () {
          var data =
            (labelMarker.getExtData && labelMarker.getExtData()) || item;
          that.table.datalist.forEach(function (d) {
            if (d.ID === data.ID) {
              d.IsAddTemp = 1;
            }
          });
          that.SetTemptableList();
        });

        labelMarkers.push(labelMarker);
        that.markers.push(labelMarker);
        that.markerMap[item.ID] = labelMarker;
      });

      if (labelMarkers.length) {
        layer.add(labelMarkers);
      }

      // 初始化矩形框选工具
      if (!this.mouseTool) {
        this.mouseTool = new AMap.MouseTool(this.map);
        this.mouseTool.on("draw", function (event) {
          var rect = event.obj;
          var bounds = rect.getBounds();
          that.table.datalist.forEach(function (item) {
            var pos = new AMap.LngLat(item.Lgt * 1, item.Lat * 1);
            if (bounds.contains(pos)) {
              item.IsAddTemp = 1;
            }
          });
          that.SetTemptableList();
          that.rectangleOverlays.push(rect);
        });
      }
    },

    // 初始化一个信息窗口
    initWindow(lat, lng, address, status, workerName, communityTitle) {
      // 一次只能打开一个窗口 打开之前先关闭之前打开的
      if (this.infoWin) {
        this.closeWindow();
      }
      var communityRow = communityTitle
        ? `<li>小区：<span>${communityTitle}</span></li>`
        : "";
      this.infoWin = new this.AMapNS.InfoWindow({
        content: `<ul class="equipment">
        ${communityRow}
        <li>地址：<span>${address || ""}</span></li>
        <li>试压员：<span class="${status == 1 ? "good" : "bad"}">        
        ${workerName}
        </span></li>        
        </ul>`,
        offset: new this.AMapNS.Pixel(0, -30),
      });
    },

    // 关闭信息窗口
    closeWindow() {
      if (this.infoWin) {
        this.infoWin.close();
      }
    },
    openMuiltSel() {
      if (this.enableMuiltSel) {
        // 关闭框选模式
        this.$Modal.info({
          title: "提示",
          content: "关闭框选模式",
        });
        if (this.mouseTool) {
          this.mouseTool.close(true);
        }
        this.rectangleOverlays.forEach((o) => this.map.remove(o));
        this.rectangleOverlays = [];
      } else {
        // 开启框选模式
        this.$Modal.info({
          title: "提示",
          content: "开启框选模式",
        });
        if (this.mouseTool) {
          this.mouseTool.rectangle({
            fillColor: "#00b0ff",
            fillOpacity: 0.3,
            strokeColor: "#00b0ff",
          });
        }
      }
      this.enableMuiltSel = !this.enableMuiltSel;
    },
  },
  created: function () {
    this.region = this.$route.query.region;
    // 挂实例属性，避开 Vue 响应式
    this.map = null;
    this.AMapNS = null;
    this.labelsLayer = null;
    this.markers = [];
    this.markerMap = {};
    this.mouseTool = null;
    this.rectangleOverlays = [];
    this.infoWin = null;
  },
  components: {
    "worker-RowSel": workerRolSel,
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var that = this;
    AMap.init().then((AMap) => {
      if (that._isDestroyed || that._isBeingDestroyed) return;
      that.AMapNS = AMap;
      that.map = new AMap.Map("map_container", {
        center: new AMap.LngLat(112.977361, 28.19652),
        zoom: 15,
        viewMode: "2D",
        doubleClickZoom: false,
        // 保留底图地名，关掉立体建筑和拖动动画减轻卡顿
        showLabel: true,
        showBuildingBlock: false,
        animateEnable: false,
        jogEnable: false,
      });
      that.GetTableList();
    });
  },
  beforeDestroy() {
    if (this.mouseTool) {
      try {
        this.mouseTool.close(true);
      } catch (e) {}
      this.mouseTool = null;
    }
    if (this.infoWin) {
      try {
        this.infoWin.close();
      } catch (e) {}
      this.infoWin = null;
    }
    if (this.labelsLayer) {
      try {
        this.labelsLayer.clear();
        this.map && this.map.remove(this.labelsLayer);
      } catch (e) {}
      this.labelsLayer = null;
    }
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
    this.markers = [];
    this.markerMap = {};
    this.rectangleOverlays = [];
    this.AMapNS = null;
  },
};
</script>

<style>
#toolControl {
  position: absolute;
  top: 20px;
  left: 0px;
  right: 0px;
  margin: auto;
  width: 120px;
  z-index: 1001;
}
#rectangle {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #333;
}
#rectangle::before {
  content: "▭";
  font-size: 24px;
}
.toolItem {
  width: 40px;
  height: 40px;
  float: left;
  margin: 1px;
  padding: 4px;
  border-radius: 3px;
  background-size: 30px 30px;
  background-position: 4px 4px;
  background-repeat: no-repeat;
  box-shadow: 0 1px 2px 0 #e4e7ef;
  background-color: #ffffff;
  border: 1px solid #ffffff;
}
.active {
  border-color: #d5dff2;
  background-color: #d5dff2;
}

.toolItem:hover {
  border-color: #789cff;
}
</style>
